import React,{useState,useEffect} from "react"
import StepsModal from "./StepsModal"
import JsonInput from "./JsonInput"

const getJson = async (endpoint) =>
{    
    if(!endpoint) return

    const json = await fetch(endpoint,
    {
        method: 'get',
        headers: {
            'Content-type': 'application/json',
        }                       
    })
    .then((response) => 
    {                                
        return response.json()
    })
    .then((response) => 
    {  
        return response
    })
    .catch((error) => 
    {               
        console.log(error)
    })
    
    return json
}   

export default function JsonStepsModal({endpoint, title, json, slug, confirmClose, startOpened, backdropClose, afterSubmit, beforeSubmit, handleCustomKeys, handleCustomValues, hardcodedData, dataTags, maxWidth, editData, onFieldChange})
{    
    const backdrop = backdropClose !== false ? backdropClose : false
    const confirm = confirmClose !== false ? confirmClose : false     
    
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(true)    
   
    const needBtn = (navigate, btn) =>
    {        
        let need       

        if(navigate) 
        {        
            navigate.map(button =>
            {
                if(button.action === btn)
                {
                    need = button.label
                }            
            })

            if(need) return need

            return false
        }       

        return false
    }

    const getValidations = (inputs) =>
    {
        const validations = []   
        
        if(!inputs) return

        inputs.map(input =>
        {                       
            const validate = input.validate
            
            switch(input.type)
            {
                case 'stars':
                    validate.push(['stars',validate[0][1]])
                    break
                
                case 'mobile':
                    validate.push(['length',`14 | Invalid Phone Number.`])
                    break
                
                case 'input':
                    switch(input.input)
                    {
                        case 'checkbox': case 'radio':
                            if(validate[0][0] === 'required')
                            {
                                const msg = validate[0][1]
                                validate.pop()
                                validate.push(['checked',msg])
                            }                                                        
                            break
                    }
                    break
            }

            if(validate)
            {               
                const field =
                {
                    name: input.key,
                    label: input.label,
                    validate: validate
                }

                validations.push(field)
            }
        })       

        return validations
    }

    const getSteps = () =>
    {
        const steps = []
        const total = () =>
        {
            let count = 0

            Object.entries(data.steps).forEach(() => 
            {
                count = count + 1 
            })

            return count
        }

        const Navigation = (index, step) =>
        {
            const navigation = [] 
            const next = {"action": "next", "label": step.next_label || "Next"}
            const back = {"action": "back", "label": step.previous_label || "Back"}
            const submit = { "action": "submit", "label": step.submit_label || "Submit"}

            if((index+1) === total()) // submit
            {
                navigation.push(back)
                navigation.push(submit)
                return navigation
            }

            if(index === 0) // first
            {
                navigation.push(next)
                return navigation
            }

            if(index > 0) // other
            {
                if(step.previous_label !== false) navigation.push(back)
                navigation.push(next)
                return navigation
            }                        
        }
        
        Object.entries(data.steps).forEach(([name, step], index) => 
        {
            const slug = name
            const fields = step.fields
            const title = step.title
            const validations = getValidations(fields)
            const width = step.width
            const navigate = Navigation(index, step)

            const newstep = 
            {
                slug: slug,
                width: width ? width.value : null,
                title: title ? title.title : false,
                next: needBtn(navigate, 'next'),
                back: needBtn(navigate, 'back'),
                submit: needBtn(navigate, 'submit'),
                validate: validations,        
                html: () => 
                {
                    if(!fields) return <></>
                    
                    return(
                        <div className={slug || ('step-'+(index+1))}>
                        {
                            fields.map(field => 
                            {                                                                
                                switch(field.type)
                                {
                                    case 'paragraph':
                                        return(
                                            <div className={`json-input${field.key !== undefined ? ' field_'+field.key : ''} json-paragraph${(field.style !== undefined ? ' '+field.style : '')}`} dangerouslySetInnerHTML={{__html: field.value}}></div>
                                        )

                                    case 'message':
                                        return(
                                            <div className={`json-input${field.key !== undefined ? ' field_'+field.key : ''} json-message${(field.style !== undefined ? ' '+field.style : '')}`} dangerouslySetInnerHTML={{__html: field.value}}></div>
                                        )
                                    
                                    default:
                                        return(<JsonInput dependencies={data.dependencies} json={field} validation={validations.filter(val => val.name === name)} onFieldChange={onFieldChange} />)                                    
                                }
                            })
                        }
                        </div>
                    )    
                }                
            }

            steps.push(newstep)
        })
        
        return steps
    }

    useEffect(() => 
    {
        (async () => 
        {
            if(json) 
            {
                setData(json)
                setLoading(false)
                return
            }        
            
            try 
            {
                setLoading(true);
                const data = await getJson(endpoint);
                setData(data);
                setLoading(false);
            } 
            catch (error) 
            {
                // add error handling here
                setLoading(true);
                console.log(error);
            }

        })()  

    }, [])

    if(loading || !data) return(<></>)
    
    return (
        <StepsModal title={title} maxWidth={maxWidth} slug={slug} steps={getSteps()} confirmClose={confirm} backdropClose={backdrop} startOpened={startOpened} endpoint={data.endpoint} thanks={data.ok} fail={data.fail} afterSubmit={afterSubmit} beforeSubmit={beforeSubmit} handleCustomKeys={handleCustomKeys} handleCustomValues={handleCustomValues} hardcodedData={hardcodedData} dataTags={dataTags} editData={editData} />
    ) 
}